function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Flex } from '@tapresearch/ui/components';
export function CustomCrossTabBarLabel(props) {
    var usePercentage = props.usePercentage, barProps = props.barProps;
    if (!barProps) {
        return null;
    }
    var _barProps_bar_data = barProps.bar.data, answerId = _barProps_bar_data.id;
    return /*#__PURE__*/ React.createElement(Flex, {
        align: "stretch",
        h: "full",
        w: "full",
        bg: barProps.bar.color,
        fontWeight: "medium",
        fontSize: "sm",
        color: "gray.900"
    }, /*#__PURE__*/ React.createElement(Flex, {
        position: 'absolute',
        justify: 'center',
        w: 'full',
        left: 0,
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        mt: '-1px'
    }, "".concat(usePercentage ? "".concat(barProps.bar.data.value, "%") : barProps.bar.data.data["".concat(answerId, "_total")])));
}
export function getCustomCrossTabBarLabel(param) {
    var usePercentage = param.usePercentage;
    // eslint-disable-next-line react/display-name
    return function(props) {
        return /*#__PURE__*/ React.createElement(CustomCrossTabBarLabel, _object_spread_props(_object_spread({}, props), {
            usePercentage: usePercentage
        }));
    };
}
